import { Moment } from 'moment';
import { DossierReference } from '@/dossier/models/AbstractDossier';
import { FullName } from '@/shared/models/common';
import Vehicle from '@/vehicle/models/Vehicle';
import TaskDossier from './TaskDossier';

export default abstract class AbstractTask {
  description = '';
  externalReference: DossierReference | null = null;
  vehicle: Vehicle | null = null;
  dossier: TaskDossier | null = null;
  contactNames: Array<FullName> = [];
  createdOn!: Moment;
}
